import validate from 'validate.js'

const constraints = {
  'input.name': {
    presence: true
  },
  'input.type': {
    presence: true
  },
}
  

export default (data) => {
  return validate(data, constraints)
}
